import { render, staticRenderFns } from "./DocumentSign.vue?vue&type=template&id=6e62679a&scoped=true&"
import script from "./DocumentSign.vue?vue&type=script&lang=js&"
export * from "./DocumentSign.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSign.vue?vue&type=style&index=0&id=6e62679a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62679a",
  null
  
)

export default component.exports